(function () {
  var STORAGE_KEY = 'gcWishlistProducts';

  function readWishlist() {
    try {
      var items = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items.filter(function (item) { return item && item.handle; }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function hasProduct(items, handle) {
    return items.some(function (item) { return item.handle === handle; });
  }

  function buttonProduct(button) {
    return {
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '#',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || '',
      vendor: button.dataset.productVendor || ''
    };
  }

  function updateButtons() {
    var items = readWishlist();
    document.querySelectorAll('[data-gc-wishlist-toggle]').forEach(function (button) {
      var active = hasProduct(items, button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Add ') + (button.dataset.productTitle || 'product') + (active ? ' from wishlist' : ' to wishlist'));
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (match) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[match];
    });
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-gc-wishlist-page]');
    if (!root) return;

    var items = readWishlist();
    var grid = root.querySelector('[data-gc-wishlist-grid]');
    var empty = root.querySelector('[data-gc-wishlist-empty]');
    var count = root.querySelector('[data-gc-wishlist-count]');

    if (count) count.textContent = String(items.length);
    if (!grid || !empty) return;

    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;

    grid.innerHTML = items.map(function (item) {
      return [
        '<article class="gc-wishlist-card">',
          '<a class="gc-wishlist-card__image" href="' + escapeHtml(item.url) + '">',
            item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '',
          '</a>',
          '<div class="gc-wishlist-card__body">',
            '<a class="gc-wishlist-card__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>',
            item.vendor ? '<p>' + escapeHtml(item.vendor) + '</p>' : '',
            item.price ? '<strong>' + escapeHtml(item.price) + '</strong>' : '',
            '<button type="button" data-gc-wishlist-remove="' + escapeHtml(item.handle) + '">Remove</button>',
          '</div>',
        '</article>'
      ].join('');
    }).join('');
  }

  function toggleProduct(button) {
    var product = buttonProduct(button);
    if (!product.handle) return;

    var items = readWishlist();
    if (hasProduct(items, product.handle)) {
      items = items.filter(function (item) { return item.handle !== product.handle; });
    } else {
      items.unshift(product);
    }

    writeWishlist(items);
    updateButtons();
    renderWishlistPage();
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-gc-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      toggleProduct(toggle);
      return;
    }

    var remove = event.target.closest('[data-gc-wishlist-remove]');
    if (remove) {
      writeWishlist(readWishlist().filter(function (item) { return item.handle !== remove.dataset.gcWishlistRemove; }));
      updateButtons();
      renderWishlistPage();
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      updateButtons();
      renderWishlistPage();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateButtons();
    renderWishlistPage();
  });
})();
